import removeNamespace from "../namespace-helper"

export const Types = {
  getters: {},
  actions: {
    REVIEWS: "publications/REVIEWS",
    REQUEST: "publications/REQUEST",
    FEED: "publications/FEED",
    FILTERS: "publications/FILTERS",
    ORDER: "publications/ORDER",
  },
  mutations: {
    REVIEWS: "publications/REVIEWS",
    REQUEST: "publications/REQUEST",
    FEED: "publications/FEED",
    FILTERS: "publications/FILTERS",
    ORDER: "publications/ORDER",
  },
}

const _types = removeNamespace("publications/", Types)

const state = {
  reviews: [],
  generateRequestInformation: [],
  feed: [],
  filters: [],
  order: "desc",
}

// getters
const getters = {}

// actions
const actions = {
  [_types.actions.REVIEWS]: ({ commit }, reviews) => {
    commit(_types.mutations.REVIEWS, reviews)
  },
  [_types.actions.REQUEST]: ({ commit }, generateRequestInformation) => {
    commit(_types.mutations.REQUEST, generateRequestInformation)
  },
  [_types.actions.FEED]: ({ commit }, feed) => {
    commit(_types.mutations.FEED, feed)
  },
  [_types.actions.FILTERS]: ({ commit }, filters) => {
    commit(_types.mutations.FILTERS, filters)
  },
  [_types.actions.ORDER]: ({ commit }, order) => {
    commit(_types.mutations.ORDER, order)
  },
}

// mutations
const mutations = {
  [_types.mutations.REVIEWS]: (state, reviews) => {
    state.reviews = reviews
  },
  [_types.mutations.REQUEST]: (state, generateRequestInformation) => {
    state.generateRequestInformation = generateRequestInformation
  },
  [_types.mutations.FEED]: (state, feed) => {
    state.feed = feed
  },
  [_types.mutations.FILTERS]: (state, filters) => {
    state.filters = filters
  },
  [_types.mutations.ORDER]: (state, order) => {
    state.order = order
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
